const variantColor = () => {
  document
    .querySelectorAll('[data-variant-color]')
    .forEach((variantElement) => {
      const currentColor = variantElement.getAttribute('data-current-color');

      const color = window.colors.find((item) => item.name === currentColor);

      if (color) {
        const hexElement = variantElement.querySelector('[data-variant-hex]');
        const nameElement = variantElement.querySelector('[data-variant-name]');

        if (hexElement) hexElement.style.backgroundColor = color.color;
        if (nameElement) nameElement.textContent = color.name;
      }
    });
};

export default variantColor;
